module.exports = __webpack_public_path__ + "img/rms.09aa07b8.png";